module.exports = __webpack_public_path__ + "@/assets/img/desapegos.63ea0b5e.jpg";